import React, { useState, useEffect, useReducer } from "react";
import Dashboard from "../../Dasboard/Dashboard";
import MUIDataTable from "mui-datatables";
import { domain } from "../../../Urls/Services/Api_urls";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import Swal from "sweetalert2";
import { Grid } from "@material-ui/core";
import { Plus, Edit, Trash, EyeAlt } from "iconoir-react";
import { Poligonadd } from "./Poligonadd";
import MapRender from "../../CoberturaFTTH/Maps";

export default function PolygonComp() {
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const token = window.sessionStorage.getItem("token");
  const [Polygonlist, setPolygonlist] = useState([]);

  const [displayDiv, setdisplayDiv] = useState("none");
  //2 - Función para mostrar los datos con fetch
  useEffect(() => {
    const getData = () => {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");

      fetch(domain + "/polygonsftth?paginate=false", {
        method: "GET",
        headers: myHeaders,
      })
        .then((data) => data.json())
        .then((data) => {
          setPolygonlist(data.data);
          
        });
    };
    getData();
  }, [ignored]);

  const columns = [
    {
      name: "id",
      label: " ",
      options: {
        viewColumns: false,
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <tr>
              <td>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    window.location.href =
                      "./PolygonEdit/" + tableMeta.rowData[0];
                  }}
                >
                  <EyeAlt style={{ color: "#5e5e5e" }} />
                </div>
              </td>
              {/* <td>
                <div
                  style={{ cursor: "pointer", textAlign: "center" }}
                  onClick={() => {
                    Swal.fire({
                      title: "Seguro que quieres eliminar el polígono",
                      icon: "question",
                      showCancelButton: true,
                      cancelButtonText: "No",
                      allowOutsideClick: false,
                      confirmButtonColor: "#3085d6",
                      showConfirmButton: true,
                      confirmButtonText: "Si",
                    }).then((result) => {
                      if (result.isConfirmed) {
                        var myHeaders = new Headers();
                        myHeaders.append("Authorization", `Bearer ${token}`);
                        myHeaders.append("Content-Type", "application/json");
                        var requestOptions = {
                          method: "DELETE",
                          headers: myHeaders,
                          redirect: "follow",
                        };
                        fetch(
                          domain + "/polygonsftth/" + tableMeta.rowData[0],
                          requestOptions
                        )
                          .then((response) => {
                            if (response.status === 204) {
                              window.location.reload();
                            } else {
                              Swal.fire("Error", response.error, "error");
                            }
                          })
                          .catch((error) => console.log("error", error));
                      }
                    });
                  }}
                >
                  <Trash style={{ color: "#5e5e5e" }} />
                </div>
              </td> */}
            </tr>
          );
        },
      },
    },
    {
      name: "id",
      label: "ID",
    },
    {
      name: "cdo",
      label: "CDO",
    },
    {
      name: "social_stratum",
      label: "ESTRATO",
    },
    {
      name: "locality_type",
      label: "ZONA",
    },
    {
      name: "city",
      label: "Ciudad",
    },
  ];

  const options = {
    rowsPerPage: 80,
    // print: false,
    fixedHeader: true,
    selectableRows: "none",
    responsive: "scrollMaxHeight",
    downloadOptions: {
      filename: `${"cdo"}.csv`,
      separator: ",",
    },
    textLabels: {
      body: {
        noMatch: "Cargando...Nada para mostrar en el momento...",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `Sort for ${column.label}`,
      },
      pagination: {
        next: "Siguiente",
        previous: "Anterior",
        rowsPerPage: "Filas:",
        displayRows: "of",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtrar datos",
      },
      filter: {
        all: "Todo",
        title: "FILTROS",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar Columnas",
        titleAria: "Mostrar/Ocultar Table Columns",
      },
      selectedRows: {
        text: "fila(s) seleccionadas",
        delete: "Borrar",
        deleteAria: "Borrar Filas",
      },
    },
    responsive: "scrollMaxHeight",
  };

  return (
    <div>
      <Dashboard
        MInicio={""}
        Msolicitudes={""}
        Mservicios={""}
        Mcompra={""}
        Mcunyompra={""}
        Mempaquetar={""}
        Mcpotenciales={""}
        Madminportal={""}
        Mcampaña={""}
        Mtv={"active"}
      >
        <section className="m-1 p-4">
          <h2 className="text-xl font-bold">Polígonos</h2>
          <div
            className="relative flex flex-col md:flex-row gap-4 mt-4 rounded-lg h-[90vh] md:h-[70vh]"
          >
            {/* Mapa */}
            <div className="flex-1 h-1/2 md:h-full">
              <MapRender
                data={Polygonlist}
                display={"none"}
                width={"100%"}
                height={"100%"}
                zoom={15}
              />
            </div>
  
            {/* Tabla */}
            <div className="flex-1 h-1/2 md:h-full overflow-auto">
              <MUIDataTable
                title={<span className="text-lg font-semibold">Lista de polígonos</span>}
                columns={columns}
                data={Polygonlist}
                options={options}
              />
            </div>
          </div>
  
          {/* Formulario para añadir polígonos */}
          <div
            className={`mt-4 shadow-lg rounded-lg ${
              displayDiv === "none" ? "hidden" : "block"
            }`}
          >
            <Poligonadd
              HandleChangeDisplay={({ target }) => setdisplayDiv(target.value)}
            />
          </div>
        </section>
      </Dashboard>
    </div>
  );
}

// ## Summary
// This code defines a React functional component named `PolygonComp` that displays a list of polygons and allows users to add, edit, and delete polygons. It uses the `useEffect` hook to fetch the polygon data from an API and updates the state with the fetched data. The component also uses the `MUIDataTable` library to display the polygon data in a table format with options for sorting, filtering, and pagination.

// ## Example Usage
// ```javascript
// <PolygonComp />
// ```

// ## Code Analysis
// ### Inputs
// - None
// ___
// ### Flow
// 1. The component initializes the `Polygonlist` state variable as an empty array and the `displayDiv` state variable as "none".
// 2. The `useEffect` hook is used to fetch the polygon data from the API when the component mounts. It sends a GET request to the specified domain with authorization headers and retrieves the data in JSON format. The fetched data is then logged to the console and stored in the `Polygonlist` state variable.
// 3. The `columns` variable defines the columns for the `MUIDataTable` component, including custom render functions for the edit and delete buttons.
// 4. The `options` variable defines the options for the `MUIDataTable` component, including the number of rows per page, custom footer, and text labels.
// 5. The component renders the `Dashboard` component with specific props to highlight the "TV" tab.
// 6. The component renders the list of polygons using the `MUIDataTable` component, passing in the columns, data, and options.
// 7. The component renders a div with a map and a button to add a new polygon. The map is rendered using the `MapRender` component, passing in the polygon data and other props.
// 8. When the "Añadir poligono" button is clicked, the `displayDiv` state variable is updated to show the form to add a new polygon.
// 9. The component renders the form to add a new polygon when the `displayDiv` state variable is not "none".
// 10. The component renders the form to add a new polygon when the `displayDiv` state variable is not "none".
// ___
// ### Outputs
// - The component renders a list of polygons with options to edit and delete each polygon.
// - The component displays a map with the polygon data.
// - The component allows users to add a new polygon.
// ___
